<template>
    <div class="flex flex-col lg:flex-row h-screen w-screen">

        <NavBar :headerService="headerService" :navModuleType="NAV_MENU_TYPE.TRIZ_PRO" :login="handleLogin"/>

        <div class="flex-1 h-full overflow-hidden" id="app-container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useHeaderService } from '@/composables/use-header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { container } from './inversify.config';
import type { LoginDialogService } from './domains/shared/services/login-dialog-service';

const { headerService } = useHeaderService();

const handleLogin = () => {
    Promise.all([
        import('./domains/shared/services/login-dialog-service'),
        import('./container-modules/login-dialog-module')
    ]).then(([{ LoginDialogService }, { loginDialogModule }]) => {
        if (!container.isBound(LoginDialogService)) {
            container.load(loginDialogModule);
        }
        const loginDialogService = injectService<LoginDialogService>(LoginDialogService);
        loginDialogService.open();
    });
};
</script>
